import type { CookieConsentCategory } from "@/shared/cookies/cookieConsent";

export type CookieConsentCategoryConfig = {
  key: CookieConsentCategory;
  title: string;
  description: string;
  isRequired: boolean;
};

export const COOKIE_CONSENT_CATEGORIES: CookieConsentCategoryConfig[] = [
  {
    key: "necessary",
    title: "Strictly Necessary Cookies",
    description:
      "These cookies are required for secure login, session management, portal routing, fraud prevention, and core platform features. They cannot be turned off.",
    isRequired: true,
  },
  {
    key: "functional",
    title: "Functional Cookies",
    description:
      "These cookies help remember your preferences, such as selected portal, language, filters, or display choices, so your experience feels smoother.",
    isRequired: false,
  },
  {
    key: "performance",
    title: "Performance Cookies",
    description:
      "These cookies help us understand site performance, page usage, and errors so we can improve ConfidaCare for patients and providers.",
    isRequired: false,
  },
  {
    key: "targeting",
    title: "Targeting Cookies",
    description:
      "These cookies may be used for campaign measurement or outreach-related experiences. They are only enabled if you allow them.",
    isRequired: false,
  },
];
